// extracted by mini-css-extract-plugin
module.exports = {"BannerDiv":"Banner_BannerDiv__3_64k","BannerImage":"Banner_BannerImage__ynO9d"};